/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_EmptyInputs */

const cs_gallery_empty = /** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné fotky.`)
};

const en_gallery_empty = /** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photos yet.`)
};

/**
* | output |
* | --- |
* | "No photos yet." |
*
* @param {Gallery_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_empty = /** @type {((inputs?: Gallery_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_empty(inputs)
	return cs_gallery_empty(inputs)
});